import { IFormTypeService } from "../../service/formconfiguration/FormTypeService";

export default class GetFormTypeEvaluationsInteractor {
  private formTypeService: IFormTypeService;

  constructor(formTypeService) {
    this.formTypeService = formTypeService;
  }

  async execute(formTypeCode: string) {
    return this.formTypeService.getFormTypeEvaluations(formTypeCode);
  }
}
